import script from "./EditSection.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__